import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export { Badge, IconWrapper } from '../../styles/nav.styles';

export const Bar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: var(--keyboard-inset-bottom, 0px);
  left: 0;
  right: 0;
  z-index: 102;
  background: ${semantic.bg.canvas};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding: ${space['space-400']} ${space['space-400']}
    calc(${space['space-400']} + env(safe-area-inset-bottom, 0px));
  height: ${layout.mobileNavHeight};
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const TabItem = styled.button<{ $active?: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-100']};
  padding: ${space['space-100']} ${space['space-400']};
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ $active }) => ($active ? semantic.text.primary : semantic.text.tertiary)};
  transition: color 0.15s ease;

  &:hover {
    color: ${semantic.text.primary};
  }
`;

export const TabLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
`;
